<template>
  <div
    class="generate-code"
    v-if="user && Object.keys(user).length && user.mdm_id"
  >
    <UserData />
    <div class="generate-code__title">Подтвердить участие</div>
    <div
      @click="requestCode"
      v-if="!codeRequested"
      class="generate-code__button button button_pink"
    >
      Cгенерировать код
    </div>
    <div v-else class="generate-code__code-block">
      <div class="generate-code__code-title">Ваш код:</div>
      <div class="generate-code__code-code">{{code}}</div>
      <div class="generate-code__code-timer">{{ time }}</div>
    </div>
  </div>
</template>

<script>
import UserData from "../../components/pageComponents/cabinet/UserData.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "GenerateCode",
  data: () => ({
    code: "",
    codeRequested: false,
    interval: null,
    duration: 0,
    time: "00:00",
  }),
  components: {
    UserData,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["fetchAlerts"]),
    requestCode() {
      this.$axios(`/api/user/generate-code`, {
        method: "POST",
      })
        .then((res) => {
          clearInterval(this.interval);
          this.code = res.data.code;
          this.codeRequested = true;
          this.duration = res.data.ttl;
          this.timer();
          this.interval = setInterval(this.timer, 1000);
        })
        .catch(() => {
          this.fetchAlerts({
            alerts: "Не удалось сгенерировать код",
            type: "error",
          });
        });
    },
    timer() {
      if (!this.duration) {
        this.codeRequested = false;
        return;
      }
      let minutes = this.duration / 60;
      let fullMinutes = Math.floor(minutes);
      let seconds = (minutes - Math.floor(minutes)) * 60;
      let fullSeconds = Math.round(seconds);
      this.duration--;
      this.time = `${fullMinutes.toString().padStart(2, 0)}:${fullSeconds
        .toString()
        .padStart(2, 0)}`;
    },
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.generate-code {
  background-color: #f8f8f8;
  padding-left: 32px;
  padding-top: 48px;
  padding-bottom: 80px;
  z-index: 1000;
  position: relative;
  @media screen and (max-width: 1220px) {
    padding-left: 0;
  }
  &__title {
    margin-bottom: 24px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }

  &__code {
    &-block {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #b2b4b4;
    }

    &-code {
      padding: 10px 12px 10px 24px;
      border-radius: 99px;
      background-color: #d2d2d2;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      color: #8a226f;
      letter-spacing: 12px;
    }

    &-timer {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #3c4242;
    }
  }
}
</style>